(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tabing"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.escape-tabs-wrapper[data-section-id]');
  if (!wrapper) return;

  const sectionId = wrapper.getAttribute('data-section-id');
  const section = document.querySelector(`.escape-tabs-${sectionId}`);

  if (section) {
    const buttons = section.querySelectorAll('.tab-buttons button');
    const contents = section.querySelectorAll('.tab-content');

    buttons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        contents[i].classList.add('active');
      });
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
